import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-cash-flow.md.
export const Route = createFileRoute('/_app/cash-flow')({
  component: CashFlowPage,
});

function CashFlowPage() {
  return <ComingSoon slug="cash-flow" />;
}
